import { SingleFieldDynamicFields } from '../singleFieldDynamicFields';
import { FormikProps } from 'formik';
import { Typography } from '@mui/material';
import { SingleDynamicField } from '../../../../../shared/types/assistant';

export const DynamicConversationMemory = ({
    formikDynamicConversationMemory,
}: {
    formikDynamicConversationMemory: FormikProps<{
        [key: string]: SingleDynamicField[];
    }>;
}) => {
    return (
        <SingleFieldDynamicFields
            formik={formikDynamicConversationMemory}
            name="dynamicConversationMemory"
            label="Memoria Conversacional Dinámica (Context Awareness)"
            description="Define las reglas para la gestión del contexto en la conversación. Especifica cómo recordar información relevante del usuario, evitar respuestas repetitivas y sugerir recursos cuando una consulta es recurrente."
            example={
                <Typography color="text.secondary">
                    Recuerda el nombre del usuario y úsalo en la conversación.
                </Typography>
            }
            rows={1}
        />
    );
};
